import { render, staticRenderFns } from "./NewFeaturesAction.vue?vue&type=template&id=140cde5f&scoped=true&"
import script from "./NewFeaturesAction.vue?vue&type=script&lang=js&"
export * from "./NewFeaturesAction.vue?vue&type=script&lang=js&"
import style0 from "./NewFeaturesAction.vue?vue&type=style&index=0&id=140cde5f&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140cde5f",
  null
  
)

export default component.exports